import { array, object, number, mixed } from 'yup'
import { safify } from '../utils/safify'

export const crossPostAccounts = array()
  .of(
    object({
      external_integration_id: number().required(),
      output_type: mixed().oneOf(['text', 'design']),
    }).transform(safify),
  )
  .meta({
    autoFill: true,
    featureFlags: {
      post_preview_v2: false,
      scheduled_posts_v3: false,
    },
  })
  .default([])
  .nullable()

export const crossPostAccountsFromDesign = crossPostAccounts.clone().meta({
  ...crossPostAccounts.describe().meta,
  isDesign: true,
})
